import {getRequest, sendRequest} from './api';

/**
 * Получение списка рабочих мест.
 * @param {string} organisation_id - Идентификатор организации.
 * @returns {Promise<any>} - Ответ от сервера.
 */
export async function fetchWorkplaces(organisation_id) {
  return getRequest('/workplace', {organisation_id});
}

/**
 * Создание нового рабочего места.
 * @param {object} data - Данные для создания рабочего места.
 * @param {string} data.organisation_id - Идентификатор организации (обязательный).
 * @param {string} data.department_id - Идентификатор отдела (обязательный).
 * @param {string} data.role_id - Идентификатор роли (обязательный).
 * @param {string} data.name - Название рабочего места (обязательный).
 * @param {number} data.price - Цена (обязательный).
 * @returns {Promise<any>} - Ответ от сервера.
 */
export async function sendCreateWorkplace(data) {
  return sendRequest('/workplace', 'POST', data);
}

/**
 * Обновление рабочего места.
 * @param {object} data - Данные для обновления рабочего места.
 * @param {string} data.id - Идентификатор рабочего места (обязательный).
 * @param {string} data.organisation_id - Идентификатор организации (обязательный).
 * @param {string} [data.status_id] - Идентификатор статуса (необязательный).
 * @param {string} [data.name] - Название рабочего места (необязательный).
 * @param {string} [data.role_id] - Идентификатор роли (необязательный).
 * @param {number} [data.price] - Цена (необязательный).
 * @returns {Promise<any>} - Ответ от сервера.
 */
export async function sendUpdateWorkplace(data) {
  return sendRequest('/workplace', 'PUT', data);
}

/**
 * Удаление рабочего места.
 * @param {object} data - Данные для удаления рабочего места.
 * @param {string} data.id - Идентификатор рабочего места (обязательный).
 * @param {string} data.organisation_id - Идентификатор организации (обязательный).
 * @returns {Promise<any>} - Ответ от сервера.
 */
export async function deleteWorkplace(data) {
  return sendRequest('/workplace', 'DELETE', data);
}

/**
 * Прикрепление работника к рабочему месту.
 * @param {object} data - Данные для прикрепления работника.
 * @param {string} data.organisation_id - Идентификатор организации (обязательный).
 * @param {string} data.workplace_id - Идентификатор рабочего места (обязательный).
 * @param {string} data.login - Логин работника (обязательный).
 * @param {string} [data.comment] - Комментарий (необязательный).
 * @returns {Promise<any>} - Ответ от сервера.
 */
export async function attachUserToWorkplace(data) {
  return sendRequest('/workplace/user', 'POST', data);
}

/**
 * Открепление работника от рабочего места.
 * @param {object} data - Данные для открепления работника.
 * @param {string} data.organisation_id - Идентификатор организации (обязательный).
 * @param {string} data.id - Идентификатор прикрепления (обязательный).
 * @returns {Promise<any>} - Ответ от сервера.
 */
export async function detachUserFromWorkplace(data) {
  return sendRequest('/workplace/user', 'DELETE', data);
}
/**
 * Получение списка работников в организации или на конкретном рабочем месте.
 * @param {object} params - Параметры запроса.
 * @param {string} params.organisation_id - Идентификатор организации (обязательный).
 * @param {string} [params.workplace_id] - Идентификатор рабочего места (необязательный).
 * @returns {Promise<any>} - Ответ от сервера.
 */
export async function getWorkplaceUsers(data) {
  return getRequest('/workplace/user', data);
}
